import React, { useState } from "react";
import { useHttpClient } from "../../../../shared/hooks/http-hook";
import FiltrosRelatorio from "../ui/filtrosRelatorio/FiltrosRelatorio";
import RelatorioPesquisaAvaliacoes from "./components/RelatorioPesquisaAvaliacoes";

const tiposRelatorios = [
  { value: "", label: "Selecione um relatório" },
  { value: "pesquisaAvaliacoes", label: "Relatório de Pesquisa" },
];

/* A chave tem de ser o `value` do relatório. Estava `avaliacoes`, que não
   corresponde a nenhum — e o `FiltrosRelatorio` deixa passar tudo o que não
   encontra, por isso os botões apareciam por acidente e não por decisão. */
const relatorioCaps = {
  pesquisaAvaliacoes: { gerar: true, exportar: true },
};

function RelatoriosAvaliacoes({ auth, clinica }) {
  const { sendRequest } = useHttpClient();
  const [dadosRelatorio, setDadosRelatorio] = useState({
    open: "",
    dataFiltro: {},
    acao: "",
    atualizacoes: 0,
  });

  const gerarRelatorioHandler = (dataInicial, dataFinal, tipoRelatorio) => {
    if (!tipoRelatorio) return;

    setDadosRelatorio((prev) => ({
      open: tipoRelatorio,
      dataFiltro: { dataInicial, dataFinal },
      acao: "gerar",
      atualizacoes: prev.atualizacoes + 1,
    }));
  };

  const exportarFicheiroHandler = (dataInicial, dataFinal, tipoRelatorio) => {
    if (!tipoRelatorio) return;

    setDadosRelatorio((prev) => ({
      open: tipoRelatorio,
      dataFiltro: { dataInicial, dataFinal },
      acao: "exportar",
      atualizacoes: prev.atualizacoes + 1,
    }));
  };

  const renderizarRelatorio = () => {
    const { open, dataFiltro, acao, atualizacoes } = dadosRelatorio;

    if (!open) return null;

    const props = {
      dataFiltro,
      clinicaId: clinica.clinica._id,
      auth,
      acao,
      sendRequest,
      atualizacoes,
    };

    switch (open) {
      case "pesquisaAvaliacoes":
        return <RelatorioPesquisaAvaliacoes {...props} />;
      default:
        return null;
    }
  };

  return (
    <>
      <FiltrosRelatorio
        tiposRelatorios={tiposRelatorios}
        gerarRelatorioHandler={gerarRelatorioHandler}
        exportarFicheiroHandler={exportarFicheiroHandler}
        relatorioCaps={relatorioCaps}
        relatorioSelecionado={dadosRelatorio.open}
      />
      {renderizarRelatorio()}
    </>
  );
}

export default RelatoriosAvaliacoes;
